module.exports = __webpack_public_path__ + "static/media/24-hours.aca1fe57.svg";